module.exports = __webpack_public_path__ + "img/1-min.9cd5efda.jpg";